class SectionSubHeader extends HTMLElement {
  constructor() {
    super();
    this.mainSelector = 'main';
    this.navItemSelector = '.sub-header_nav_item';
    this.offsetSelectors = ['sticky-header', '.menudrawer-main.open', '.section-sub-header'];
    this.activeClass = 'is_active';
  }

  static get observedAttributes() {
    return [];
  }

  connectedCallback() {
    this.init();
  }

  calculateTotalOffset() {
    return this.offsetSelectors.reduce((total, selector) => {
      const element = document.querySelector(selector);
      const height = element ? element.getBoundingClientRect().height : 0;
      return total + height;
    }, 0);
  }

  handleNavItemClick(event, link, mainChildren) {
    event.preventDefault();
    const targetIndex = parseInt(link.getAttribute('href').replace('#', ''), 10);

    const linkText = link.textContent
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, '-');

    if (!isNaN(targetIndex) && mainChildren[targetIndex]) {
      const targetElement = mainChildren[targetIndex];

      const totalOffset = this.calculateTotalOffset();
          const rect = targetElement.getBoundingClientRect();
const style = window.getComputedStyle(targetElement);
let paddingTop = parseFloat(style.paddingTop) || 0;

if (paddingTop === 0 && targetElement.children.length > 0) {
  let firstRelevantChild = null;
  for (let child of targetElement.children) {
    if (child.tagName === 'DIV' && child.tagName !== 'A' && child.tagName !== 'LINK') {
      firstRelevantChild = child;
      break;
    }
  }
  if (firstRelevantChild) {
    const childStyle = window.getComputedStyle(firstRelevantChild);
    paddingTop = parseFloat(childStyle.paddingTop) || 0;
  }
   console.log('FirstElementChild:', firstRelevantChild);
}

     const elementPosition = rect.top + window.scrollY + paddingTop;

      window.scrollTo({
        top: elementPosition - totalOffset,
        behavior: 'smooth',
      });

      window.location.hash = `#${linkText}`;

      document.querySelectorAll('.sub-header_nav.is_active').forEach(el => el.classList.remove('is_active'));
      const parentNav = link.closest('.sub-header_nav');
      if (parentNav) parentNav.classList.add('is_active');
    } else {
      console.error('Invalid target index or element not found.');
    }
  }

  handleScroll(mainChildren, navItems) {
    const totalOffset = this.calculateTotalOffset();
    let anyActive = false;

    navItems.forEach((link) => {
      const parentLi = link.closest('li');
      if (!parentLi) return;

      const href = link.getAttribute('href') || '';
      const targetIndex = parseInt(href.replace('#', ''), 10);
      const child = Number.isInteger(targetIndex) && mainChildren[targetIndex] ? mainChildren[targetIndex] : null;

      if (!child) {
        parentLi.classList.remove(this.activeClass);
        return;
      }

      const rect = child.getBoundingClientRect();
      const midpointViewport = rect.top + rect.height / 2;
      const isVisibleMidpoint = midpointViewport >= totalOffset && midpointViewport <= window.innerHeight;

      if (isVisibleMidpoint && !anyActive) {
        parentLi.classList.add(this.activeClass);
        anyActive = true;

        const linkText = link.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9\s]/g, '')
          .replace(/\s+/g, '-');

        if (window.location.hash !== `#${linkText}`) {
          window.location.hash = `#${linkText}`;
        }
      } else {
        parentLi.classList.remove(this.activeClass);
      }
    });

    if (!anyActive && window.location.hash) {
      const cleanUrl = window.location.pathname + window.location.search;
      window.history.replaceState(null, '', cleanUrl);
    }
  }

  init() {
     window.history.replaceState(null, '', window.location.pathname + window.location.search);

    const main = document.querySelector(this.mainSelector);
    if (!main) {
      console.error('Main element not found.');
      return;
    }

    const mainChildren = Array.from(main.children).slice(1);
    const navItems = document.querySelectorAll(this.navItemSelector);

    if (navItems.length === 0) {
      console.error('Navigation items not found.');
      return;
    }

    navItems.forEach((link) => {
      link.addEventListener('click', (event) => this.handleNavItemClick(event, link, mainChildren));
    });

    window.addEventListener('scroll', () => this.handleScroll(mainChildren, navItems));

    window.history.replaceState(null, '', window.location.pathname);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('section-sub-header', SectionSubHeader);
});